export class ProductionUnitFieldParameter {
  min: number | undefined;
  max: number | undefined;
}
